import { useEffect, useState } from "react";
import { BsHearts } from "react-icons/bs";
import { FaAngleDown, FaAngleRight, FaUsers } from "react-icons/fa";
import { FaToiletPaper } from "react-icons/fa6";
import { GiMoneyStack } from "react-icons/gi";
import { GoDotFill } from "react-icons/go";
import { GrNotes } from "react-icons/gr";
import {
  IoAperture,
  IoDiamond,
  IoLanguage,
  IoOptions,
  IoRibbon,
} from "react-icons/io5";
import { MdDashboard } from "react-icons/md";
import { RiGroup3Fill } from "react-icons/ri";
import { RxCross2 } from "react-icons/rx";
import { SiNordicsemiconductor } from "react-icons/si";
import { VscFeedback } from "react-icons/vsc";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logoImage from "../assets/Group.png";
import styles from "./css/Sidebar.module.scss";

//  MdOutlineSpeakerNotes

const Sidebar = ({ isSidebarOpen, toggleSidebar }) => {
  // State to manage the active submenu and active submenu item
  const [activeSubMenu, setActiveSubMenu] = useState(null);
  const [activeSubMenuItem, setActiveSubMenuItem] = useState(null);

  // Retrieve the "homeActive" value from localStorage
  const getHomeActive = localStorage.getItem("homeActive");
  const location = useLocation();
  const navigate = useNavigate();

  // Determine active menu and submenu from URL
  useEffect(() => {
    const path = location.pathname;

    setActiveSubMenu(null);
    setActiveSubMenuItem(null);

    if (path === "/home/dashboard") {
      setActiveSubMenu("dashboard");
    } else if (path.startsWith("/home/user")) {
      setActiveSubMenu("user");
    } else if (path.startsWith("/home/add-interest")) {
      setActiveSubMenu("interest");
      setActiveSubMenuItem("add-interest");
    } else if (path.startsWith("/home/list-interest")) {
      setActiveSubMenu("interest");
      setActiveSubMenuItem("list-interest");
    } else if (path.startsWith("/home/add-language")) {
      setActiveSubMenu("language");
      setActiveSubMenuItem("add-language");
    } else if (path.startsWith("/home/list-language")) {
      setActiveSubMenu("language");
      setActiveSubMenuItem("list-language");
    } else if (path.startsWith("/home/add-religion")) {
      setActiveSubMenu("religion");
      setActiveSubMenuItem("add-religion");
    } else if (path.startsWith("/home/list-religion")) {
      setActiveSubMenu("religion");
      setActiveSubMenuItem("list-religion");
    } else if (path.startsWith("/home/add-relation")) {
      setActiveSubMenu("relation");
      setActiveSubMenuItem("add-relation");
    } else if (path.startsWith("/home/list-relation")) {
      setActiveSubMenu("relation");
      setActiveSubMenuItem("list-relation");
    } else if (path.startsWith("/home/add-communities")) {
      setActiveSubMenu("communities");
      setActiveSubMenuItem("add-communities");
    } else if (path.startsWith("/home/list-communities")) {
      setActiveSubMenu("communities");
      setActiveSubMenuItem("list-communities");
    } else if (path.startsWith("/home/add-qualities")) {
      setActiveSubMenu("qualities");
      setActiveSubMenuItem("add-qualities");
    } else if (path.startsWith("/home/list-qualities")) {
      setActiveSubMenu("qualities");
      setActiveSubMenuItem("list-qualities");
    } else if (path.startsWith("/home/add-preference")) {
      setActiveSubMenu("preference");
      setActiveSubMenuItem("add-preference");
    } else if (path.startsWith("/home/list-preference")) {
      setActiveSubMenu("preference");
      setActiveSubMenuItem("list-preference");
    } else if (path.startsWith("/home/add-category")) {
      setActiveSubMenu("habbits");
      setActiveSubMenuItem("add-category");
    } else if (path.startsWith("/home/list-category")) {
      setActiveSubMenu("habbits");
      setActiveSubMenuItem("list-category");
    } else if (path.startsWith("/home/add-sub-category")) {
      setActiveSubMenu("sub-category");
      setActiveSubMenuItem("add-sub-category");
    } else if (path.startsWith("/home/list-sub-category")) {
      setActiveSubMenu("sub-category");
      setActiveSubMenuItem("list-sub-category");
    } else if (path.startsWith("/home/add-report")) {
      setActiveSubMenu("report-category");
      setActiveSubMenuItem("add-report");
    } else if (path.startsWith("/home/list-report")) {
      setActiveSubMenu("report-category");
      setActiveSubMenuItem("list-report");
    }
    // Add more conditions here for other sections if needed
  }, [location.pathname]);

  // Click handlers
  const handleSubMenuClick = (subMenu) => {
    localStorage.setItem("homeActive", "false");

    if (activeSubMenu === subMenu) {
      setActiveSubMenu(null);
    } else {
      setActiveSubMenu(subMenu);
      localStorage.setItem("activeSubMenu", subMenu);

      if (subMenu === "interest") {
        navigate("/home/list-interest");
        setActiveSubMenuItem("list-interest");
      }
      if (subMenu === "language") {
        navigate("/home/list-language");
        setActiveSubMenuItem("list-language");
      }
      if (subMenu === "religion") {
        navigate("/home/list-religion");
        setActiveSubMenuItem("list-religion");
      }
      if (subMenu === "relation") {
        navigate("/home/list-relation");
        setActiveSubMenuItem("list-relation");
      }
      if (subMenu === "communities") {
        navigate("/home/list-communities");
        setActiveSubMenuItem("list-communities");
      }
      if (subMenu === "qualities") {
        navigate("/home/list-qualities");
        setActiveSubMenuItem("list-qualities");
      }
      if (subMenu === "preference") {
        navigate("/home/list-preference");
        setActiveSubMenuItem("list-preference");
      }
      if (subMenu === "habbits") {
        navigate("/home/list-category");
        setActiveSubMenuItem("list-category");
      }
      if (subMenu === "sub-category") {
        navigate("/home/list-sub-category");
        setActiveSubMenuItem("list-sub-category");
      }
      if (subMenu === "report-category") {
        navigate("/home/list-report");
        setActiveSubMenuItem("list-report");
      }
    }

    localStorage.removeItem("activeSubMenuItem");
  };

  const handleSubMenuItemClick = (subMenuItem) => {
    setActiveSubMenuItem(subMenuItem);
    localStorage.setItem("activeSubMenuItem", subMenuItem);
    if (window.innerWidth <= 768) {
      toggleSidebar();
    }
  };

  const handleWithoutClick = (link) => {
    localStorage.setItem("homeActive", "false");
    if (activeSubMenu === link) return;
    setActiveSubMenu(link);
    if (window.innerWidth <= 768) {
      toggleSidebar();
    }
  };

  useEffect(() => {
    const path = location.pathname;

    setActiveSubMenu(null);
    setActiveSubMenuItem(null);

    if (path === "/home/dashboard") {
      setActiveSubMenu("dashboard");
    } else if (path.startsWith("/home/user")) {
      setActiveSubMenu("user");
    } else if (path.startsWith("/home/plan")) {
      setActiveSubMenu("plan");
    } else if (path.startsWith("/home/add-plan")) {
      setActiveSubMenu("plan");
      setActiveSubMenuItem("add-plan");
    } else if (path.startsWith("/home/payment")) {
      setActiveSubMenu("payment");
    } else if (path.startsWith("/home/report")) {
      setActiveSubMenu("report");
    } else if (path.startsWith("/home/feedback")) {
      setActiveSubMenu("feedback");
    } else if (path.startsWith("/home/page")) {
      setActiveSubMenu("page");
    } else if (path.startsWith("/home/add-page")) {
      setActiveSubMenu("page");
      setActiveSubMenuItem("/home/add-page");
    } else if (path.startsWith("/home/add-interest")) {
      setActiveSubMenu("interest");
      setActiveSubMenuItem("add-interest");
    } else if (path.startsWith("/home/list-interest")) {
      setActiveSubMenu("interest");
      setActiveSubMenuItem("list-interest");
    } else if (path.startsWith("/home/add-language")) {
      setActiveSubMenu("language");
      setActiveSubMenuItem("add-language");
    } else if (path.startsWith("/home/list-language")) {
      setActiveSubMenu("language");
      setActiveSubMenuItem("list-language");
    } else if (path.startsWith("/home/add-religion")) {
      setActiveSubMenu("religion");
      setActiveSubMenuItem("add-religion");
    } else if (path.startsWith("/home/list-religion")) {
      setActiveSubMenu("religion");
      setActiveSubMenuItem("list-religion");
    } else if (path.startsWith("/home/add-relation")) {
      setActiveSubMenu("relation");
      setActiveSubMenuItem("add-relation");
    } else if (path.startsWith("/home/list-relation")) {
      setActiveSubMenu("relation");
      setActiveSubMenuItem("list-relation");
    } else if (path.startsWith("/home/add-communities")) {
      setActiveSubMenu("communities");
      setActiveSubMenuItem("add-communities");
    } else if (path.startsWith("/home/list-communities")) {
      setActiveSubMenu("communities");
      setActiveSubMenuItem("list-communities");
    } else if (path.startsWith("/home/add-qualities")) {
      setActiveSubMenu("qualities");
      setActiveSubMenuItem("add-qualities");
    } else if (path.startsWith("/home/list-qualities")) {
      setActiveSubMenu("qualities");
      setActiveSubMenuItem("list-qualities");
    } else if (path.startsWith("/home/add-preference")) {
      setActiveSubMenu("preference");
      setActiveSubMenuItem("add-preference");
    } else if (path.startsWith("/home/list-preference")) {
      setActiveSubMenu("preference");
      setActiveSubMenuItem("list-preference");
    } else if (path.startsWith("/home/add-category")) {
      setActiveSubMenu("habbits");
      setActiveSubMenuItem("add-category");
    } else if (path.startsWith("/home/list-category")) {
      setActiveSubMenu("habbits");
      setActiveSubMenuItem("list-category");
    } else if (path.startsWith("/home/add-sub-category")) {
      setActiveSubMenu("sub-category");
      setActiveSubMenuItem("add-sub-category");
    } else if (path.startsWith("/home/list-sub-category")) {
      setActiveSubMenu("sub-category");
      setActiveSubMenuItem("list-sub-category");
    } else if (path.startsWith("/home/add-report")) {
      setActiveSubMenu("report-category");
      setActiveSubMenuItem("add-report");
    } else if (path.startsWith("/home/list-report")) {
      setActiveSubMenu("report-category");
      setActiveSubMenuItem("list-report");
    }
  }, [location.pathname]);

  return (
    <>
      <div
        className={`${styles.sidebar} ${
          isSidebarOpen ? styles.open : styles.closed
        }`}
      >
        <div
          className={`${styles.logo} ${!isSidebarOpen ? styles.hidden : ""}`}
        >
          <img
            src={logoImage}
            alt="Logo"
            className={`${!isSidebarOpen ? styles.hidden : ""}`}
          />
          <RxCross2 className={styles.close_icon} onClick={toggleSidebar} />
        </div>
        <div className={styles.category_list}>
          <ul>
            {/* Dashboard Menu Item */}
            <li
              className={`${styles.sidebar_links} ${
                activeSubMenu === "dashboard" ? styles.interest_clicked : ""
              } ${getHomeActive === "true" ? styles.interest_clicked : ""}`}
            >
              <Link
                to="dashboard"
                onClick={() => handleWithoutClick("dashboard")}
              >
                <div className={styles.icon_and_link}>
                  <MdDashboard />
                  Dashboard
                </div>
              </Link>
            </li>
            {/* User Menu Item */}
            <li
              className={`${styles.sidebar_links} ${
                activeSubMenu === "user" ? styles.interest_clicked : ""
              }`}
            >
              <Link to="user" onClick={() => handleWithoutClick("user")}>
                <div className={styles.icon_and_link}>
                  <RiGroup3Fill />
                  User List
                </div>
              </Link>
            </li>
            {/* Interest Submenu */}
            <li
              className={`${styles.sidebar_links} ${
                activeSubMenu === "interest" ? styles.submenu_clicked : ""
              }`}
            >
              <div
                onClick={() => handleSubMenuClick("interest")}
                className={styles.icon_and_link}
              >
                <BsHearts />
                <span>Interest</span>
                {activeSubMenu === "interest" ? (
                  <FaAngleDown className={styles.chevron_down} />
                ) : (
                  <FaAngleRight className={styles.chevron_right} />
                )}
              </div>
              {activeSubMenu === "interest" && (
                <ul className={styles.submenu}>
                  <li
                    className={`${
                      activeSubMenuItem === "add-interest" ? styles.active : ""
                    }`}
                    onClick={() => handleSubMenuItemClick("add-interest")}
                  >
                    <Link to="add-interest">
                      <GoDotFill /> Add Interest
                    </Link>
                  </li>
                  <li
                    className={`${
                      activeSubMenuItem === "list-interest" ? styles.active : ""
                    }`}
                    onClick={() => handleSubMenuItemClick("list-interest")}
                  >
                    <Link to="list-interest">
                      <GoDotFill /> List Interest
                    </Link>
                  </li>
                </ul>
              )}
            </li>
            {/* Language Submenu */}
            <li
              className={`${styles.sidebar_links} ${
                activeSubMenu === "language" ? styles.submenu_clicked : ""
              }`}
            >
              <div
                onClick={() => handleSubMenuClick("language")}
                className={styles.icon_and_link}
              >
                <IoLanguage />
                <span>Language</span>
                {activeSubMenu === "language" ? (
                  <FaAngleDown className={styles.chevron_down} />
                ) : (
                  <FaAngleRight className={styles.chevron_right} />
                )}
              </div>
              {activeSubMenu === "language" && (
                <ul className={styles.submenu}>
                  <li
                    className={`${
                      activeSubMenuItem === "add-language" ? styles.active : ""
                    }`}
                    onClick={() => handleSubMenuItemClick("add-language")}
                  >
                    <Link to="add-language">
                      <GoDotFill /> Add language
                    </Link>
                  </li>
                  <li
                    className={`${
                      activeSubMenuItem === "list-language" ? styles.active : ""
                    }`}
                    onClick={() => handleSubMenuItemClick("list-language")}
                  >
                    <Link to="list-language">
                      <GoDotFill /> List language
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            {/* Religion Submenu */}
            <li
              className={`${styles.sidebar_links} ${
                activeSubMenu === "religion" ? styles.submenu_clicked : ""
              }`}
            >
              <div
                onClick={() => handleSubMenuClick("religion")}
                className={styles.icon_and_link}
              >
                <IoAperture />
                <span>Religion</span>
                {activeSubMenu === "religion" ? (
                  <FaAngleDown className={styles.chevron_down} />
                ) : (
                  <FaAngleRight className={styles.chevron_right} />
                )}
              </div>
              {activeSubMenu === "religion" && (
                <ul className={styles.submenu}>
                  <li
                    className={`${
                      activeSubMenuItem === "add-religion" ? styles.active : ""
                    }`}
                    onClick={() => handleSubMenuItemClick("add-religion")}
                  >
                    <Link to="add-religion">
                      <GoDotFill /> Add religion
                    </Link>
                  </li>
                  <li
                    className={`${
                      activeSubMenuItem === "list-religion" ? styles.active : ""
                    }`}
                    onClick={() => handleSubMenuItemClick("list-religion")}
                  >
                    <Link to="list-religion">
                      <GoDotFill /> List religion
                    </Link>
                  </li>
                </ul>
              )}
            </li>
            {/* Relation Goal Submenu */}
            <li
              className={`${styles.sidebar_links} ${
                activeSubMenu === "relation" ? styles.submenu_clicked : ""
              }`}
            >
              <div
                onClick={() => handleSubMenuClick("relation")}
                className={styles.icon_and_link}
              >
                <IoDiamond />
                <span>Relation Goal</span>
                {activeSubMenu === "relation" ? (
                  <FaAngleDown className={styles.chevron_down} />
                ) : (
                  <FaAngleRight className={styles.chevron_right} />
                )}
              </div>
              {activeSubMenu === "relation" && (
                <ul className={styles.submenu}>
                  <li
                    className={`${
                      activeSubMenuItem === "add-relation" ? styles.active : ""
                    }`}
                    onClick={() => handleSubMenuItemClick("add-relation")}
                  >
                    <Link to="add-relation">
                      <GoDotFill /> Add relation
                    </Link>
                  </li>
                  <li
                    className={`${
                      activeSubMenuItem === "list-relation" ? styles.active : ""
                    }`}
                    onClick={() => handleSubMenuItemClick("list-relation")}
                  >
                    <Link to="list-relation">
                      <GoDotFill /> List relation
                    </Link>
                  </li>
                </ul>
              )}
            </li>
            {/* Communities Submenu */}
            <li
              className={`${styles.sidebar_links} ${
                activeSubMenu === "communities" ? styles.submenu_clicked : ""
              }`}
            >
              <div
                onClick={() => handleSubMenuClick("communities")}
                className={styles.icon_and_link}
              >
                <FaUsers />
                <span>Communities </span>
                {activeSubMenu === "communities" ? (
                  <FaAngleDown className={styles.chevron_down} />
                ) : (
                  <FaAngleRight className={styles.chevron_right} />
                )}
              </div>
              {activeSubMenu === "communities" && (
                <ul className={styles.submenu}>
                  <li
                    className={`${
                      activeSubMenuItem === "add-communities"
                        ? styles.active
                        : ""
                    }`}
                    onClick={() => handleSubMenuItemClick("add-communities")}
                  >
                    <Link to="add-communities">
                      <GoDotFill /> Add communities
                    </Link>
                  </li>
                  <li
                    className={`${
                      activeSubMenuItem === "list-communities"
                        ? styles.active
                        : ""
                    }`}
                    onClick={() => handleSubMenuItemClick("list-communities")}
                  >
                    <Link to="list-communities">
                      <GoDotFill /> List communities
                    </Link>
                  </li>
                </ul>
              )}
            </li>
            {/* Qualities selection submenu */}
            <li
              className={`${styles.sidebar_links} ${
                activeSubMenu === "qualities" ? styles.submenu_clicked : ""
              }`}
            >
              <div
                onClick={() => handleSubMenuClick("qualities")}
                className={styles.icon_and_link}
              >
                <IoRibbon />
                <span>Qualities </span>
                {activeSubMenu === "qualities" ? (
                  <FaAngleDown className={styles.chevron_down} />
                ) : (
                  <FaAngleRight className={styles.chevron_right} />
                )}
              </div>
              {activeSubMenu === "qualities" && (
                <ul className={styles.submenu}>
                  <li
                    className={`${
                      activeSubMenuItem === "add-qualities" ? styles.active : ""
                    }`}
                    onClick={() => handleSubMenuItemClick("add-qualities")}
                  >
                    <Link to="add-qualities">
                      <GoDotFill /> Add qualities
                    </Link>
                  </li>
                  <li
                    className={`${
                      activeSubMenuItem === "list-qualities"
                        ? styles.active
                        : ""
                    }`}
                    onClick={() => handleSubMenuItemClick("list-qualities")}
                  >
                    <Link to="list-qualities">
                      <GoDotFill /> List qualities
                    </Link>
                  </li>
                </ul>
              )}
            </li>
            {/* preference submenu */}
            <li
              className={`${styles.sidebar_links} ${
                activeSubMenu === "preference" ? styles.submenu_clicked : ""
              }`}
            >
              <div
                onClick={() => handleSubMenuClick("preference")}
                className={styles.icon_and_link}
              >
                <IoOptions />
                <span>Preference </span>
                {activeSubMenu === "preference" ? (
                  <FaAngleDown className={styles.chevron_down} />
                ) : (
                  <FaAngleRight className={styles.chevron_right} />
                )}
              </div>
              {activeSubMenu === "preference" && (
                <ul className={styles.submenu}>
                  <li
                    className={`${
                      activeSubMenuItem === "add-preference"
                        ? styles.active
                        : ""
                    }`}
                    onClick={() => handleSubMenuItemClick("add-preference")}
                  >
                    <Link to="add-preference">
                      <GoDotFill /> Add preference
                    </Link>
                  </li>
                  <li
                    className={`${
                      activeSubMenuItem === "list-preference"
                        ? styles.active
                        : ""
                    }`}
                    onClick={() => handleSubMenuItemClick("list-preference")}
                  >
                    <Link to="list-preference">
                      <GoDotFill /> List preference
                    </Link>
                  </li>
                </ul>
              )}
            </li>
            {/* Category Submenu */}
            <li
              className={`${styles.sidebar_links} ${
                activeSubMenu === "habbits" ? styles.submenu_clicked : ""
              }`}
            >
              <div
                onClick={() => handleSubMenuClick("habbits")}
                className={styles.icon_and_link}
              >
                <SiNordicsemiconductor />
                <span>Category </span>
                {activeSubMenu === "habbits" ? (
                  <FaAngleDown className={styles.chevron_down} />
                ) : (
                  <FaAngleRight className={styles.chevron_right} />
                )}
              </div>
              {activeSubMenu === "habbits" && (
                <ul className={styles.submenu}>
                  <li
                    className={`${
                      activeSubMenuItem === "add-category" ? styles.active : ""
                    }`}
                    onClick={() => handleSubMenuItemClick("add-category")}
                  >
                    <Link to="add-category">
                      <GoDotFill /> Add Category
                    </Link>
                  </li>
                  <li
                    className={`${
                      activeSubMenuItem === "list-category" ? styles.active : ""
                    }`}
                    onClick={() => handleSubMenuItemClick("list-category")}
                  >
                    <Link to="list-category">
                      <GoDotFill /> List Category
                    </Link>
                  </li>
                </ul>
              )}
            </li>
            {/* Sub-category submenu */}
            <li
              className={`${styles.sidebar_links} ${
                activeSubMenu === "sub-category" ? styles.submenu_clicked : ""
              }`}
            >
              <div
                onClick={() => handleSubMenuClick("sub-category")}
                className={styles.icon_and_link}
              >
                <SiNordicsemiconductor />
                <span>Sub-Category </span>
                {activeSubMenu === "sub-category" ? (
                  <FaAngleDown className={styles.chevron_down} />
                ) : (
                  <FaAngleRight className={styles.chevron_right} />
                )}
              </div>
              {activeSubMenu === "sub-category" && (
                <ul className={styles.submenu}>
                  <li
                    className={`${
                      activeSubMenuItem === "add-sub-category"
                        ? styles.active
                        : ""
                    }`}
                    onClick={() => handleSubMenuItemClick("add-sub-category")}
                  >
                    <Link to="add-sub-category">
                      <GoDotFill /> Add sub-category
                    </Link>
                  </li>
                  <li
                    className={`${
                      activeSubMenuItem === "list-sub-category"
                        ? styles.active
                        : ""
                    }`}
                    onClick={() => handleSubMenuItemClick("list-sub-category")}
                  >
                    <Link to="list-sub-category">
                      <GoDotFill /> List sub-category
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            {/* Plan Menu */}
            {/* <li
              className={`${styles.sidebar_links} ${
                activeSubMenu === "plan" ? styles.interest_clicked : ""
              }`}
            >
              <Link to="plan" onClick={() => handleWithoutClick("plan")}>
                <div className={styles.icon_and_link}>
                  <FaHandHoldingDollar />
                  Plan
                </div>
              </Link>
            </li> */}
            {/* Payment Menu */}
            <li
              className={`${styles.sidebar_links} ${
                activeSubMenu === "payment" ? styles.interest_clicked : ""
              }`}
            >
              <Link to="payment" onClick={() => handleWithoutClick("payment")}>
                <div className={styles.icon_and_link}>
                  <GiMoneyStack />
                  Payment List
                </div>
              </Link>
            </li>
            {/* Repport category Submenu */}
            <li
              className={`${styles.sidebar_links} ${
                activeSubMenu === "report-category"
                  ? styles.submenu_clicked
                  : ""
              }`}
            >
              <div
                onClick={() => handleSubMenuClick("report-category")}
                className={styles.icon_and_link}
              >
                <GrNotes />
                <span>Report Category</span>
                {activeSubMenu === "report-category" ? (
                  <FaAngleDown className={styles.chevron_down} />
                ) : (
                  <FaAngleRight className={styles.chevron_right} />
                )}
              </div>
              {activeSubMenu === "report-category" && (
                <ul className={styles.submenu}>
                  <li
                    className={`${
                      activeSubMenuItem === "add-report" ? styles.active : ""
                    }`}
                    onClick={() => handleSubMenuItemClick("add-report")}
                  >
                    <Link to="add-report">
                      <GoDotFill /> Add report
                    </Link>
                  </li>
                  <li
                    className={`${
                      activeSubMenuItem === "list-report" ? styles.active : ""
                    }`}
                    onClick={() => handleSubMenuItemClick("list-report")}
                  >
                    <Link to="list-report">
                      <GoDotFill /> List report
                    </Link>
                  </li>
                </ul>
              )}
            </li>
            {/* Report Menu */}
            <li
              className={`${styles.sidebar_links} ${
                activeSubMenu === "report" ? styles.interest_clicked : ""
              }`}
            >
              <Link to="report" onClick={() => handleWithoutClick("report")}>
                <div className={styles.icon_and_link}>
                  <GrNotes />
                  Report List
                </div>
              </Link>
            </li>
            {/* Feedback Menu */}
            <li
              className={`${styles.sidebar_links} ${
                activeSubMenu === "feedback" ? styles.interest_clicked : ""
              }`}
            >
              <Link
                to="feedback"
                onClick={() => handleWithoutClick("feedback")}
              >
                <div className={styles.icon_and_link}>
                  <VscFeedback />
                  Feedback
                </div>
              </Link>
            </li>
            {/* Page Menu */}
            <li
              className={`${styles.sidebar_links} ${
                activeSubMenu === "page" ? styles.interest_clicked : ""
              }`}
            >
              <Link to="page" onClick={() => handleWithoutClick("page")}>
                <div className={styles.icon_and_link}>
                  <FaToiletPaper />
                  Page
                </div>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
